
import React from 'react';
import { Building } from '@/types/portfolio';
import { BuildingCard } from '@/components/portfolio/BuildingCard';

interface BuildingsListProps {
  buildings: Building[];
  onDelete: (id: string) => void;
}

export const BuildingsList = ({ buildings, onDelete }: BuildingsListProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {buildings.map((building) => (
        <BuildingCard
          key={building.id}
          building={building}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};
